export default __webpack_public_path__ + "static/font-91f42e94d3f72aaef79a57dcbf98d9ed.woff";